<template>
    <div class="r-snackbar" :class="!show ? 'r-snackbar-hide' : 'r-snackbar-show'"> 
        <div class="r-snackbar-box r-center-flex">
            <img class="r-snackbar-icon" :src="require(`@/assets/icons/toast/${snackbar.type == null ? 'info' : snackbar.type}.svg`)">
            <div class="r-snackbar-text r-600">
                {{snackbar.text}}
            </div>
            <div class="r-snackbar-action r-center-flex" v-if="snackbar.withclose">
                <img :src="require('@/assets/icons/black/close.svg')" alt="" @click.prevent="hideSnackbar()">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    watch: {
        show(){
            this.setTime()
        }
    },
    computed:{
        show(){
            return this.snackbar.show
        },
        snackbar(){
            return this.$store.getters['getSnackbar']
        }
    },
    data: () => ({
        hideSnackbarTime: null
    }),
    methods:{
        setTime() {
            clearTimeout(this.hideSnackbarTime);
            this.hideSnackbarTime = setTimeout( () => {this.$store.dispatch("hideSnackbar")}, 2000);
        },
        clearTime() {
            clearTimeout(this.hideSnackbarTime);
        },
        hideSnackbar(){
            this.$store.dispatch("hideSnackbar")
        }
    }
}
</script>
<style scoped lang="scss">
.r-snackbar-icon{
    min-width: 24px;
    margin-right: 10px;
}
.r-snackbar-show{
    top: calc(100vh - 70px);
    transition: all 500ms ease-in;
}
.r-snackbar-hide{
    top: 100vh;
    transition: all 500ms ease-out;
}
.r-snackbar{
    position: fixed;
    width: 300px;
    left: calc(50% - 150px);
    min-height: 50px;
    z-index: 10000000000;
}
</style>